import React, { StrictMode } from "react";
import { Provider } from "react-redux";
import { createRoot } from 'react-dom/client';

import App from "./App";
import store from "./store";
import CONFIG from './config';
import ErrorBoundary from "./ErrorBoundary";

import "bootstrap/dist/js/bootstrap.min.js";
require("./themes/" + CONFIG.SHOP_ID + "/settings.scss");

Array.from(document.getElementsByTagName('body')).forEach(body => {
  if (body && body.classList) {
    Object.keys(CONFIG.themeClasses).forEach(t => {
      body.classList.remove(CONFIG.themeClasses[t]);
    });
    body.classList.add(CONFIG.themeClasses[localStorage.getItem("theme") || "default"]);
    if (CONFIG.isVerseNeo() && CONFIG.isKundenShop()) {
      body.classList.add("kundenshop");
    }
  }
});

const container = document.getElementById("rechner_SE_SHOP");
if (container) {
  const root = createRoot(container); // createRoot(container!) if you use TypeScript

  root.render(
    <StrictMode>
      <Provider store={store}>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </Provider>
    </StrictMode>
  );
}


